import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	connect() {
	}

	toggle(e) {
		const { params: { targets } } = e;
		targets.forEach(({ selector, className, op = 'toggle' }) => {
			this.do(selector, className, op);
		});
	}

	do(selector, className, op = 'toggle') {
		const element = document.querySelector(selector);
		if (!element) {
			console.warn(`Element with selector "${selector}" not found`);

			return;
		}

		switch (op) {
			case 'toggle':
				element.classList.toggle(className);
				break;
			case 'add':
				element.classList.add(className);
				break;
			case 'remove':
				element.classList.remove(className);
				break;
		}
	}
}
